// extracted by mini-css-extract-plugin
export var author = "comments-module--author--b353f";
export var comment = "comments-module--comment--d97dd";
export var commentBody = "comments-module--commentBody--d891e";
export var commentList = "comments-module--commentList--bf8d6";
export var comments__lead = "comments-module--comments__lead--be230";
export var content = "comments-module--content--fcd6e";
export var fn = "comments-module--fn--51b71";
export var metadata = "comments-module--metadata--377e3";
export var rating = "comments-module--rating--1082e";
export var replyTitle = "comments-module--replyTitle--82deb";
export var respond = "comments-module--respond--a8e92";